module.exports = __webpack_public_path__ + "media/images/img_star_01-5aa2506065f79a34d72b5d422659251b.png";